import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { EvaluationFamilyType } from '@/enums/evaluation/evaluation.enum';
import { EvaluationDetail, EvaluationListItem } from '@/models/evaluation/evaluation.model';

export interface EvaluationUseCases {
  getEvaluations(evaluationFamilyType: EvaluationFamilyType): Observable<EvaluationListItem[]>;
  getEvaluationDetail(evaluationId: number): Observable<EvaluationDetail>;
}

export const EVALUATION_USE_CASES = new InjectionToken<EvaluationUseCases>('EVALUATION_USE_CASES');
